<div class="g-layout__container" [dir]="dir">

    <!-- Page Header -->
    <div class="page-header">
        <div class="header-left">
            <h1 class="page-title">
                <i class="fa-solid fa-chart-line"></i>
                {{ 'IndicatorSOutcomes' | navTitle | async }}
            </h1>
        </div>
    </div>

    <!-- Goals Filter Only -->
    <div class="filters-container mt-4">
        <div class="filter-section-solo">
            <label class="filter-label">
                <i class="fa-solid fa-bullseye"></i>
                {{'select_goal_indicators' | translate }}
            </label>
            <div class="dropdown-wrapper">
                <p-dropdown [(ngModel)]="goal_id" (onChange)="onGoalChange()" [options]="goalsOptions"
                    optionLabel="goal_name" optionValue="goal_id" placeholder="{{'select_goal'|translate}}" [appendTo]="'body'"></p-dropdown>
            </div>
        </div>
    </div>

    <!-- Indicators Grid -->
    @if (indicators && indicators.length > 0) {
    <div class="indicators-grid mt-4">
        @for(indicator of indicators; track indicator.id) {
        <div class="indicator-card">
            <!-- Header with badges -->
            <div class="card-header">
                <span class="code-badge">{{ indicator.code || 'IND-' + indicator.id }}</span>
                <span class="cycle-badge">{{ indicator.measurement_cycle_name || (dir === 'rtl' ? 'شهري' : 'Monthly') }}</span>
            </div>

            <!-- Indicator Name -->
            <h3 class="indicator-name">{{ indicator.name }}</h3>

            <!-- Chart Display (Dual Chart Only) -->
            @if (indicator.dualChartOptions) {
            <div class="chart-container mt-3">
                <apx-chart
                    [series]="indicator.dualChartOptions.series"
                    [chart]="indicator.dualChartOptions.chart"
                    [plotOptions]="indicator.dualChartOptions.plotOptions"
                    [dataLabels]="indicator.dualChartOptions.dataLabels"
                    [stroke]="indicator.dualChartOptions.stroke"
                    [xaxis]="indicator.dualChartOptions.xaxis"
                    [yaxis]="indicator.dualChartOptions.yaxis"
                    [colors]="indicator.dualChartOptions.colors"
                    [legend]="indicator.dualChartOptions.legend"
                    [tooltip]="indicator.dualChartOptions.tooltip"
                    [grid]="indicator.dualChartOptions.grid">
                </apx-chart>
                <div class="cycle-info">
                    {{ dir === 'rtl' ? 'دورية القياس :' : 'Measurement Cycle:' }} {{ indicator.measurement_cycle_name || (dir === 'rtl' ? 'غير محدد' : 'N/A') }}
                </div>
            </div>
            } @else {
            <div class="no-chart-data">
                <i class="fa-solid fa-chart-simple"></i>
                <span>{{ dir === 'rtl' ? 'لا توجد بيانات متاحة' : 'No data available' }}</span>
            </div>
            }
        </div>
        }
    </div>
    } @else {
    <div class="no-data-message mt-5">
        <i class="fa-solid fa-chart-line"></i>
        <p>{{ dir === 'rtl' ? 'يرجى اختيار هدف لعرض مؤشراته' : 'Please select a goal to view its indicators' }}</p>
    </div>
    }

</div>

<!-- Indicator Details Modal -->
<p-dialog
  [(visible)]="indicatorModalVisible"
  [modal]="true"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [breakpoints]="{ '1199px': '95vw', '575px': '98vw' }"
  [maximizable]="true"
  [dir]="dir">
  
  <ng-template pTemplate="header">
    <div class="modal-header-content">
      <div class="modal-title">
        <i class="fa-solid fa-chart-line"></i>
        <h3>{{ selectedIndicator?.name }}</h3>
      </div>
      <div class="modal-meta">
        <span class="responsible-badge">
          <i class="fa-solid fa-user-tie"></i>
          {{ selectedIndicator?.in_charge_name }}
        </span>
      </div>
    </div>
  </ng-template>

  <div class="modal-body">
    <!-- Basic Info Section -->
    <div class="basic-info-section">
      <div class="info-row">
        <div class="info-item">
          <span class="info-label">
            <i class="fa-solid fa-hashtag"></i>
            {{ dir === 'rtl' ? 'الرمز' : 'Code' }}
          </span>
          <span class="info-value-text">{{ selectedIndicator?.code || 'IND-' + selectedIndicator?.id }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">
            <i class="fa-solid fa-tag"></i>
            {{ dir === 'rtl' ? 'اسم المؤشر' : 'Indicator Name' }}
          </span>
          <span class="info-value-text">{{ selectedIndicator?.name }}</span>
        </div>
      </div>
    </div>

    <!-- Stats Grid -->
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-icon" style="background: linear-gradient(135deg, #009688, #A71932);">
          <i class="fa-solid fa-chart-line"></i>
        </div>
        <div class="stat-content">
          <span class="stat-label">{{ dir === 'rtl' ? 'الأداء' : 'Performance' }}</span>
          <span class="stat-value">{{ selectedIndicator?.performance || 0 }}%</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon" style="background: linear-gradient(135deg, #10b981, #059669);">
          <i class="fa-solid fa-calendar-check"></i>
        </div>
        <div class="stat-content">
          <span class="stat-label">{{ dir === 'rtl' ? 'دورية القياس' : 'Cycle' }}</span>
          <span class="stat-value">{{ selectedIndicator?.measurement_cycle_name || 'N/A' }}</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon" style="background: linear-gradient(135deg, #6b7280, #4b5563);">
          <i class="fa-solid fa-arrow-trend-up"></i>
        </div>
        <div class="stat-content">
          <span class="stat-label">{{ dir === 'rtl' ? 'الاتجاه' : 'Trend' }}</span>
          <span class="stat-value">{{ selectedIndicator?.trend > 0 ? '+' : '' }}{{ selectedIndicator?.trend | number:'1.1-1' }}%</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon" [style.background]="'linear-gradient(135deg, ' + getPerformanceColor(selectedIndicator?.performance || 0) + ', ' + getPerformanceColor(selectedIndicator?.performance || 0) + 'dd)'">
          <i class="fa-solid fa-flag"></i>
        </div>
        <div class="stat-content">
          <span class="stat-label">{{ dir === 'rtl' ? 'الحالة' : 'Status' }}</span>
          <span class="stat-value">{{ getPerformanceStatus(selectedIndicator?.performance || 0) }}</span>
        </div>
      </div>
    </div>

    <!-- Chart Section -->
    @if (selectedIndicator && selectedIndicator.dualChartOptions) {
    <div class="modal-chart-section">
      <div class="section-header">
        <i class="fa-solid fa-chart-column"></i>
        <span>{{ dir === 'rtl' ? 'الرسم البياني للأداء' : 'Performance Chart' }}</span>
      </div>
      <div class="modal-chart-container">
        <apx-chart
            [series]="selectedIndicator.dualChartOptions.series"
            [chart]="selectedIndicator.dualChartOptions.chart"
            [plotOptions]="selectedIndicator.dualChartOptions.plotOptions"
            [dataLabels]="selectedIndicator.dualChartOptions.dataLabels"
            [stroke]="selectedIndicator.dualChartOptions.stroke"
            [xaxis]="selectedIndicator.dualChartOptions.xaxis"
            [yaxis]="selectedIndicator.dualChartOptions.yaxis"
            [colors]="selectedIndicator.dualChartOptions.colors"
            [legend]="selectedIndicator.dualChartOptions.legend"
            [tooltip]="selectedIndicator.dualChartOptions.tooltip"
            [grid]="selectedIndicator.dualChartOptions.grid">
        </apx-chart>
      </div>
    </div>
    }

    <!-- Details Section -->
    <div class="details-section">
      <div class="detail-item">
        <div class="detail-header">
          <i class="fa-solid fa-bullseye"></i>
          <span>{{ dir === 'rtl' ? 'القيمة المستهدفة' : 'Target Value' }}</span>
        </div>
        <div class="detail-content">
          {{ selectedIndicator?.target || 'N/A' }}
        </div>
      </div>

      <div class="detail-item">
        <div class="detail-header">
          <i class="fa-solid fa-align-left"></i>
          <span>{{ dir === 'rtl' ? 'الوصف' : 'Description' }}</span>
        </div>
        <div class="detail-content">
          {{ selectedIndicator?.description || (dir === 'rtl' ? 'لا يوجد وصف متاح' : 'No description available') }}
        </div>
      </div>
    </div>

  </div>
</p-dialog>